import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ElementKeyDirective, UserService } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { ImageComponent } from '@frontend/vanilla/shared/image';

import { AccountMenuItemBase } from '../account-menu-item-base';
import { AccountMenuScrollService } from '../account-menu-scroll.service';
import { AccountMenuVipService } from '../account-menu-vip.service';

@Component({
    imports: [CommonModule, ElementKeyDirective, ImageComponent, IconCustomComponent],
    selector: 'vn-am-header-avatar',
    templateUrl: 'header-avatar.html',
})
export class HeaderAvatarComponent extends AccountMenuItemBase implements OnInit {
    userService = inject(UserService);
    accountMenuVipService = inject(AccountMenuVipService);
    private accountMenuScrollService = inject(AccountMenuScrollService);

    scrolled: boolean;
    iconClass: string;
    private readonly destroyRef = inject(DestroyRef);

    ngOnInit() {
        this.iconClass = this.item.parameters?.['avatar-icon-class'] || 'theme-account';
        this.accountMenuScrollService.scroll.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((pos: number) => {
            this.scrolled = pos > 0;
        });
    }

    restore() {
        this.accountMenuScrollService.scrollTo(0, 0);
    }
}
